import React, { useEffect } from "react";

const Toast = ({
  title = "",
  message = "",
  onClose = () => {},
  duration = 4000,
  variant = "default",
}) => {
  const isError = variant === "error";
  const isSuccess = variant === "success";

  useEffect(() => {
    const id = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(id);
  }, [duration, onClose]);

  return (
    <div className="fixed top-6 right-6 z-[200] max-w-md w-[calc(100%-3rem)]">
      <div
        className={`flex items-start gap-3 rounded-lg border shadow-lg p-4 ${
          isError
            ? "border-red-200 bg-red-50"
            : isSuccess
              ? "border-emerald-200 bg-emerald-50"
              : "border-yellow-200 bg-yellow-50"
        }`}
      >
        <div
          className={`mt-0.5 ${
            isError
              ? "text-red-600"
              : isSuccess
                ? "text-emerald-600"
                : "text-yellow-700"
          }`}
        >
          {isError ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          ) : isSuccess ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.29 3.86L1.82 18a1 1 0 00.86 1.5h18.64a1 1 0 00.86-1.5L13.71 3.86a1 1 0 00-1.72 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v4m0 4h.01" />
            </svg>
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div
            className={`font-bold ${
              isError
                ? "text-red-900"
                : isSuccess
                  ? "text-emerald-900"
                  : "text-yellow-900"
            }`}
          >
            {title}
          </div>
          <div
            className={`text-sm break-words ${
              isError
                ? "text-red-800"
                : isSuccess
                  ? "text-emerald-800"
                  : "text-yellow-800"
            }`}
          >
            {message}
          </div>
        </div>

        <button
          onClick={onClose}
          aria-label="close toast"
          className={`shrink-0 opacity-80 hover:opacity-100 ${
            isError
              ? "text-red-900"
              : isSuccess
                ? "text-emerald-900"
                : "text-yellow-900"
          }`}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default Toast;
